export default __webpack_public_path__ + "static/media/tube-3-en.220cf8fa.svg";